import React, { useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AdminAuth from './AdminAuth';
import AdminSidebar from './AdminSidebar';
import AdminDashboard from './AdminDashboard'
import AdminUserManagement from './AdminUserManagement'
import AdminSubscriptionManagement from './AdminSubscriptionManagement'
import AdminAnalytics from './AdminAnalytics'
import AdminSettings from './AdminSettings'
import AdminAuditLogs from './AdminAuditLogs'

const AdminApp = () => {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <AdminAuth>
      <div className="flex h-screen bg-gray-50">
        <AdminSidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />

        {/* Main content */}
        <div className="flex-1 md:ml-64 flex flex-col min-w-0">
          {/* Mobile top bar */}
          <div className="md:hidden flex items-center justify-between bg-white border-b border-gray-200 px-4 h-14 sticky top-0 z-20">
            <button
              onClick={() => setMobileOpen(true)}
              aria-label="Open menu"
              className="p-2 -ml-2 rounded-md text-gray-600 hover:bg-gray-100"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <span className="text-sm font-semibold text-gray-700">Logislip Admin</span>
            <span className="w-6" />
          </div>

          <div className="py-6 overflow-y-auto flex-1">
            <Routes>
              <Route path="" element={<AdminDashboard />} />
              <Route path="users" element={<AdminUserManagement />} />
              <Route path="subscriptions" element={<AdminSubscriptionManagement />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="audit" element={<AdminAuditLogs />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="*" element={<Navigate to="/admin" replace />} />
            </Routes>
          </div>
        </div>
      </div>
    </AdminAuth>
  )
}

export default AdminApp